import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { DefaultPage, AuthRoutes, ProtectedRoutes } from "./components";
import { TasksProvider } from "./context/tasks/store";

// Si tu utilises les *containers* :
import { LoginContainer } from "./pages/Login/Login.container";
import { DashboardContainer } from "./pages/Dashboard/Dashboard.container";

// Si chez toi c’est plutôt `./pages` qui ré-exporte les pages toutes faites,
// remplace les 2 imports ci-dessus par :
// import { Dashboard, Login } from "./pages";

function App() {
  return (
    <DefaultPage>
      {/* Le provider en haut de l'app pour éviter les surprises */}
      <TasksProvider>
        <BrowserRouter>
          <Routes>
            {/* Routes publiques (pas connecté) */}
            <Route element={<AuthRoutes />}>
              <Route path="/login" element={<LoginContainer />} />
              {/* <Route path="/register" element={<Register />} /> */}
            </Route>

            {/* Routes protégées */}
            <Route element={<ProtectedRoutes />}>
              <Route path="/dashboard" element={<DashboardContainer />} />
              {/* Si connecté, / redirige vers /dashboard */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </TasksProvider>
    </DefaultPage>
  );
}

export default App;